<template>
  <svg viewBox="0 0 150 150" fill="none" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <mask id="icon">
        <rect width="100%" height="100%" fill="white" />
        <path
          d="M41.668 75L66.668 100L108.335 50"
          stroke="black"
          stroke-width="8"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </mask>
    </defs>
    <circle cx="75" cy="75" r="75" fill="currentColor" mask="url(#icon)" />
  </svg>
</template>
